<template>
    <v-card>
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <v-checkbox
                    class="pt-5 mr-5"
                    v-model="showTrashed"
                    label="Afisare informatiile sterse"
                />
                <v-text-field
                    v-model.lazy="search"
                    append-icon="mdi-magnify"
                    label="Cautare..."
                    single-line
                    hide-details
                ></v-text-field>
                <v-btn
                    color="primary"
                    dark
                    class="ml-2"
                    @click="addNewItem"
                >
                    Adaugare
                </v-btn>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            :expanded.sync="expanded"
            :single-expand="true"
            show-expand
            class="elevation-1"
        >
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="canDelete(item)"
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:item.name="{ item }">
                {{ item.name }} {{ item.surname }}
            </template>
            <template v-slot:item.name="{ item }">
                {{ item.name }} {{ item.surname }}
            </template>
            <template v-slot:item.arr_code="{ item }">
                {{ _.get(item, 'last_contract.arr_code') }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ new Date(item.created_at) | date }}
            </template>
            <template v-slot:item.created_by="{ item }">
                {{ item.created_by.name }}<br/>
                {{ item.updated_by.name }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="px-2 py-2">
                    <v-simple-table class="elevation-20">
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <td width="30%">Data platii</td>
                                <td width="30%">Numar document</td>
                                <td width="15%">Valoare</td>
                                <td width="15%">Metoda de plata</td>
                            </tr>
                            </thead>
                            <tbody v-if="_.get(expanded, '0.payments', []).length">
                            <tr v-for="(payment, paymentIndex) in expanded[0].payments" :key="paymentIndex">
                                <td>{{ new Date(payment.payment_date) | date }}</td>
                                <td>{{ payment.document_no }}</td>
                                <td>{{ payment.amount | price }}</td>
                                <td>{{ _.get(Static.paymentTypesConfig, payment.method, 'Nedefinit') }}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="5">
                                    <v-alert dense type="info">
                                        Nu sunt plati inregistrate pentru acest document.
                                    </v-alert>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </td>
            </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <payment-dialog v-if="paymentDialog" :dialog="paymentDialog" :payment="payment" :expense="expanded[0]" @close="closePaymentDialog"></payment-dialog>
        <payment-delete-dialog v-if="paymentDeleteDialog" :dialog="paymentDeleteDialog" :payment="payment" :expense="expanded[0]" @close="closePaymentDeleteDialog"></payment-delete-dialog>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    import PaymentDialog from "Components/common/PaymentDialog";
    import PaymentDeleteDialog from "Components/common/PaymentDeleteDialog";
    export default {
        extends: SmartTable,
        components: {
            PaymentDialog,
            PaymentDeleteDialog
        },
        data: () => ({
            title: 'Cursanti',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Nume', value: 'name' },
                { text: 'Telefon', value: 'phone' },
                { text: 'Localitate', value: 'city' },
                { text: 'Adresa', value: 'address' },
                { text: 'CNP', value: 'id_pin' },
                { text: 'Cod ARR', value: 'arr_code' },
                { text: 'Data inregistrarii', value: 'created_at' },
                { text: 'Adaugat/Creat de', value: 'created_by' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            meta: {
                pagination: {
                    count: 0,
                    current_page: 0,
                    per_page: 0,
                    total: 0,
                    total_pages: 0
                }
            },
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
            editedIndex: -1,
            editedItem: {
            },
            defaultItem: {
            },
            expanded: undefined,
            paymentDialog: false,
            paymentDeleteDialog: false,
            payment: undefined,
            showTrashed: false
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            showTrashed: {
                handler(val) {
                    this.initialize()
                }
            },
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                var query = this.$db.Customer
                    .include('payments', 'lastContract', 'createdBy', 'updatedBy')
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
            },

            editItem (item) {
                this.$router.push({ name: 'customers-edit', params: { id: item.id } })
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Customer) {
                    await item.delete()
                } else {
                    console.warn('Here comes the headache...')
                }
                this.dialogDelete = false
                await this.initialize()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function() {
                this.$router.push({ name: 'customers-create' })
            }
        },
    };
</script>
